import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rt-toolbar-primary',
  templateUrl: './toolbar-primary.component.html',
  styleUrls: ['./toolbar-primary.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarPrimaryComponent {}
